<template>
  <div class="content-repeater">
    <section v-for="(fields, i) in data" :key="i + fields.sys.id">
      <template v-if="fields.sys.contentType.sys.id === 'portfolioList'">
        <PortfolioVertical
          id="top"
          v-if="isMobile()"
          :list="fields.fields.list"
        />
        <PortfolioHorizontal id="top" v-else :data="fields.fields.list" />
      </template>

      <TestimonialList
        id="about"
        v-else-if="fields.sys.contentType.sys.id === 'testimonialList'"
        :data="fields.fields.testimonials"
      ></TestimonialList>
    </section>
  </div>
</template>

<script>
import PortfolioHorizontal from './PortfolioHorizontal.vue'
import PortfolioVertical from './PortfolioVertical.vue'
import TestimonialList from './TestimonialList.vue'
import { isMobile } from '@/helpers'

export default {
  props: ['data'],
  components: {
    PortfolioHorizontal,
    PortfolioVertical,
    TestimonialList,
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.content-repeater {
  text-align: start;
  width: 100%;
  padding-bottom: 0%;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentRepeater.vue